<template>
  <div class="sub-page">
    <div class="header-athletes">
      <a-select default-value="全部组别" style="width: 120px">
        <a-select-option value="全部组别">
          全部组别
        </a-select-option>
      </a-select>
      <a-select placeholder="请选择比赛项目" style="width: 150px">
        <a-select-option value="全部组别">
          全部组别
        </a-select-option>
      </a-select>
      <a-select placeholder="请选择代表团" style="width: 150px">
        <a-select-option value="全部组别">
          全部组别
        </a-select-option>
      </a-select>
    </div>
    <div class="card-box">
      <h3>全部组别/所有项目/所有代表团</h3>
      <div class="par-box">
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
        <div class="card-item">
          <img src="http://static.daoba.com//262920787176.jpg"/>
          <h4>李小龙</h4>
          <div>代表队</div>
          <div>参赛项目</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name:'Athletes',
  props:{ 
  },
  data () {
    return {
    }
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
.sub-page{
  border-top: 1px solid #E4E4E4;
  background-color: #FBFBFB;
  padding-top: 30px;
}
.header-athletes{
  width:1200px;
  border-radius:10px;
  background: white;
  height: 60px;
  box-shadow: 0 0px 4px 4px rgba(0,0,0,0.03);
  margin: 0 auto;
  padding: 15px;
}
.card-box{
  width:1200px;
  border-radius:10px;
  background: white;
  box-shadow: 0 0px 4px 4px rgba(0,0,0,0.03);
  margin: 10px auto;
  padding: 15px;
  overflow: hidden;
}
.par-box{
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  justify-content: left;
  /* align-content: flex-start; */
  align-items: left;
}
.card-item{
  width: 19%;
  height: 310px;
  background: rgb(233, 231, 231);
  border-radius:10px;
  float: left;
  padding: 10px;
  margin-bottom: 1%;
  margin: 0.5%;
  h4{
    margin-top: 15px;
  }
  div{
    color:gray;
  }
}
.card-item img{
    width: 100%;
    height: 200px;
  }
</style>


// WEBPACK FOOTER //
// src/district/views/schedule/components/Athletes.vue